import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'

import { Card, CardBody, CardHeader } from '@/components/ui/Card'

/**
 * 계정 안내 플레이스홀더 — **라우트만 연결한다** (요구사항 1, 설계 §2-1(g)·D10).
 *
 * 🚨 비밀번호 재설정·회원가입 **기능은 만들지 않는다.** 서버가 그 표면을 소유하지 않고
 * (#583 비범위: 가입·비밀번호 찾기는 `/member/v1/account/**` 소관, 구장 관리자 가입 API 는 없다),
 * 요구사항도 *"라우트만 연결"* 로 못 박았다. 기능이 생기면 이 화면의 본문만 교체한다.
 *
 * 🚨 공개 라우트다 — 로그인하지 못한 사람이 오는 화면이므로 세션 가드를 두지 않는다.
 */
function AccountHelpLayout({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="mx-auto max-w-[520px] px-6 py-16">
      <Card>
        <CardHeader title={title} />
        <CardBody className="space-y-4">
          <div className="space-y-2 text-sm leading-relaxed text-slateish-600">{children}</div>
          <Link to="/login" className="inline-block text-sm text-brand-500 underline">
            로그인으로 돌아가기
          </Link>
        </CardBody>
      </Card>
    </div>
  )
}

export function AccountPasswordResetPage() {
  return (
    <AccountHelpLayout title="비밀번호 찾기">
      <p>
        구장 관리자 계정의 비밀번호는 현재 화면에서 직접 재설정할 수 없습니다. 페이스콕 담당자에게
        문의하시면 본인 확인 후 재설정을 도와드립니다.
      </p>
      <p>문의 시 구장명과 관리자 아이디를 함께 알려 주세요.</p>
    </AccountHelpLayout>
  )
}

export function AccountSignupGuidePage() {
  return (
    <AccountHelpLayout title="구장 관리자 가입 안내">
      <p>
        구장 관리자 계정은 페이스콕 담당자가 구장 입점 심사 후 발급합니다. 구장 입점이 처음이시라면
        담당자에게 입점 문의를 남겨 주세요.
      </p>
      <p>
        이미 페이스콕 회원이시라면 그 계정이 관리자 계정으로 연결됩니다. 어떤 계정이 관리자 계정인지
        알 수 없다면 담당자에게 계정 확인을 요청해 주세요.
      </p>
    </AccountHelpLayout>
  )
}
